import { render } from "./EditHospitalMarketers.vue?vue&type=template&id=2be662eb"
import script from "./EditHospitalMarketers.vue?vue&type=script&lang=js"
export * from "./EditHospitalMarketers.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/hospitals/marketers/EditHospitalMarketers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2be662eb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2be662eb', __exports__)) {
    console.log('reload')
    api.reload('2be662eb', __exports__)
  }
  
  module.hot.accept("./EditHospitalMarketers.vue?vue&type=template&id=2be662eb", () => {
    console.log('re-render')
    api.rerender('2be662eb', render)
  })

}


export default __exports__